export class TipoABM {
    public readonly ALTA: string = "ALTA";
    public readonly BAJA: string = "BAJA";
    public readonly MODIFICACION: string = "MODIFICACION";

    constructor() { }
}
